
























































































import { Vue, Component } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { EplItemStatus, eplItemStatusIconMap, EplLookupMethod } from "@/shared/types";
import { Html5QrcodeSupportedFormats, scanBarcode } from "@/shared/barcodeScanner";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import SigisLicenseAgreement from "@/employee/components/product-scanner/SigisLicenseAgreement.vue";
import { useProductScannerStore } from "@/employee/store/productScanner";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useNotifierStore } from "@/shared/store/notifier";
import * as datadog from "@/shared/datadog";

@Component({
  components: {
    GenericLoadingSpinner,
    SigisLicenseAgreement
  }
})
export default class ProductScanner extends Vue {
  $validator: Validator;
  Html5QrcodeSupportedFormats = Html5QrcodeSupportedFormats;

  productScannerStore = useProductScannerStore();
  signingDocumentStore = useSigningDocumentStore();
  hsabAccountsStore = useHsabAccountsStore();
  notifierStore = useNotifierStore();

  manualEntry = false;
  productCode = "";
  statusIcon = eplItemStatusIconMap[EplItemStatus.None];
  statusMessage = "";
  unsupportedCode = false;
  // Note: Apple Vision does not distinguish between UPC_A and EAN_13.
  supportedFormats = [Html5QrcodeSupportedFormats.UPC_A, Html5QrcodeSupportedFormats.EAN_13, Html5QrcodeSupportedFormats.ITF];
  minLength = 12;
  maxLength = 14;


  get scanOptionsHeader () {
    return this.productScannerStore.awaitingScan
      ? "Select an option below:"
      : "Check eligibility of another product:";
  }

  get showDisclaimer () {
    return this.hsabAccountsStore.userHasAnyNotionalAccounts;
  }

  get showResults () {
    return !this.productScannerStore.awaitingScan || this.unsupportedCode;
  }

  mounted () {
    this.productScannerStore.initializeState();
  }

  onManualEntryClick () {
    this.manualEntry = true;
    this.$nextTick(() => {
      (this.$refs.productCodeInput as any).focus();
    });
  }

  lookupProductCode () {
    this.$validator.validate()
      .then(isValid => {
        if (!isValid) {
          return;
        }

        this.lookup(this.productCode, EplLookupMethod.ManualEntry);
      });
  }

  lookup (productCodeString: string, method: EplLookupMethod) {
    this.unsupportedCode = false;
    this.productScannerStore.lookupItem({ productCode: productCodeString, method })
      .then(response => {
        this.statusIcon = eplItemStatusIconMap[response.status];
        this.statusMessage = response.statusMessage;
        this.manualEntry = false;
        this.productCode = "";
      })
      .catch(() => {/* noop */ });
  }

  openScannerWindow () {
    return scanBarcode()
    .then(result => {
      if (result) {
        const barcodeFormat = result.format;
        const barcodeText = result.ScanResult.trim().toUpperCase();
        const cleanBarcodeText = this.stripLeadingZeros(barcodeText);
        if (this.isValidBarcode(barcodeFormat, cleanBarcodeText)) {
          this.lookup(cleanBarcodeText, EplLookupMethod.Scan);
          return;
        } else {
          datadog.log("Unsupported barcode.", {format: barcodeFormat, code: barcodeText}, "info");
          this.productScannerStore.initializeState();
          this.statusIcon = eplItemStatusIconMap[EplItemStatus.Invalid];
          this.statusMessage = "Not supported. Please try another product.";
          this.unsupportedCode = true;
        }
      }
    })
    .catch(_ => {
      this.notifierStore.setDanger("Error processing your request. Please try again later.");
    });
  }

  stripLeadingZeros (str) {
    return str.replace(/^0*(.*)/, "$1") || "0";
  }

  isValidBarcode (format: number, code: string): boolean {
    if ((this.supportedFormats === undefined || this.supportedFormats.length === 0 ||
      this.supportedFormats.includes(format))
      && (this.minLength === undefined || !Number(this.minLength) || code.length === this.minLength
        || this.maxLength === undefined || !Number(this.maxLength) || code.length === this.maxLength)
    ) {
      return true;
    }
    return false;
  }
}
